// Voir Plus de Photos - Fonctionnalite
document.addEventListener('DOMContentLoaded', function() {
  initSeeMorePhotos();
});

function initSeeMorePhotos() {
  const galleries = document.querySelectorAll('.product__media-gallery');

  galleries.forEach(gallery => {
    // Skip if already initialized
    if (gallery.classList.contains('product__media-gallery--limited')) return;

    const mediaItems = gallery.querySelectorAll('.product__media-item');
    const totalPhotos = mediaItems.length;
    const visibleLimit = 4;

    if (totalPhotos <= visibleLimit) return;

    gallery.classList.add('product__media-gallery--limited');

    const wrapper = document.createElement('div');
    wrapper.className = 'see-more-photos-wrapper';

    wrapper.innerHTML = '<button type="button" class="see-more-photos-btn" aria-label="Voir plus de photos"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" /></svg><span>Voir plus de photos</span></button>';

    // Insert the button IN the gallery (position absolute)
    gallery.appendChild(wrapper);

    const btn = wrapper.querySelector('.see-more-photos-btn');
    btn.addEventListener('click', function() {
      gallery.classList.add('show-all');
      wrapper.style.display = 'none';

      // Update Swiper if present
      const mediaGallery = gallery.closest('media-gallery') || gallery;
      if (mediaGallery.sliderInstance && mediaGallery.sliderInstance.slider) {
        setTimeout(function() { mediaGallery.sliderInstance.slider.update(); }, 100);
      }

      gallery.dispatchEvent(new CustomEvent('photos:expanded'));
    });
  });
}

// Re-init on section reload (Shopify editor)
document.addEventListener('shopify:section:load', initSeeMorePhotos);

// Make globally accessible for re-initialization
window.initSeeMorePhotos = initSeeMorePhotos;
